module.exports = __webpack_public_path__ + "img/a3.32349437.jpg";